import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';
import ProductAliasList from '../components/rts/ProductAlias/ProductAliasList';
import ProductAliasHeader from '../components/rts/ProductAlias/ProductAliasHeader';
import ProductAliasFilter from '../components/rts/ProductAlias/ProductAliasFilter';

import { useSessionContext } from '../contexts/SessionContext';

export default function ProductAliasPage( props ){
    //console.debug("RTS Break ProductAliasPage");

    const {curFilter, user, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [filter, setFilter] = useState();   
    const [data, setData] = useState([]);


    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/ProductAlias/GetProductAliasSummary";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
            }
            setIsLoading(false);
            setHasError(false);
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status == 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token]);

    
    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'ProductAliasPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({user:user, customer:sessionCustomer.customer, type:-1, status:1, sortBy:0});
            fetchData({user:user, customer:sessionCustomer.customer, type:-1, status:1, sortBy:0})
        }
    }, [props, user, sessionCustomer, curFilter, fetchData]); 


    function dataRefresh(){
        setIsLoading(true);
        fetchData();
    };
    
    
    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    

    
    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    ;}


    return(
        <>

        <Box>
            <ProductAliasHeader />
            <ProductAliasFilter filter={filter} setFilterFx={setFilter}/>
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <ProductAliasList data={data} dataRefreshFx={dataRefresh}/>
            </Box>
        </Box>
        </>
    );

}
